// This is just an example,
// so you can safely delete all default props below

export default {
  site: {
    title: 'StatusChecker',
  },
  btn: {
    logout: 'Logout',
    update: 'Update',
    create: 'Create',
    delete: 'Delete',
    action: 'Action',
    add: 'Add',
    edit: 'Edit',
    view: 'View',
    cancel: 'Cancel',
  },
  page: {
    dashboard: { name: 'Dashboard' },
    events: { name: 'Events' },
    incidents: { name: 'Incidents' },
    enquetes: { name: 'Enquetes' },
    questionTemplates: { name: 'Question Templates' },
    mailTemplates: { name: 'Mail Tempaltes' },
    enqueteTemplates: { name: 'Enquete Templates' },
    accounts: { name: 'Accounts' },
    groups: { name: 'Groups' },
    groupTypes: { name: 'Group Types' },
    resourceTypes: { name: 'Resource Types' },
    resources: { name: 'Resources' },
    groupResources: {
      name: 'Groups And Resources',
      noGroup: { name: 'No Group' },
    },
  },
  field: {
    common: { id: 'ID', name: 'name', email: 'email', keyword: 'keyword' },
  },
  pageType: { create: 'Create', edit: 'Edit', search: 'Search' },
  validation: {
    required: 'Field is required.',
    selectionRequired: 'Selection required.',
    email: 'Please format email address.',
    min: 'Must be at least %{length} characters.',
    max: 'Please keep it under %{length} characters.',
    includeLowercase: 'Please include lower case alphabetical characters.',
    includeUppercase: 'Please include upper case alphabetical characters.',
  },
  failed: 'Action failed',
  success: 'Action was successful',
};
